<template>
    <div class="bg-white p-6 shadow-md rounded-xl h-full">
        <h2 class="text-lg font-semibold text-gray-700 mb-4 flex items-center">
            <span class="mr-2">🏷️</span>
            <span>Partners by Classification</span>
        </h2>
        <div v-if="hasData" class="chart-container">
            <apexchart type="bar" :height="chartHeight" :options="chartOptions" :series="chartSeries" @dataPointSelection="onBarSelect" />
        </div>
        <div v-else class="chart-empty">
            <span class="chart-empty-icon">📊</span>
            <p class="chart-empty-text">No data available</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PartnersByClassificationChart",
    props: {
        data: {
            type: Array,
            default: function () {
                return [];
            }
        },
        fillToCount: {
            type: Number,
            default: 0
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartHeight() {
            var ownCount = this.data && this.data.length ? this.data.length : 7;
            var matchCount = this.fillToCount && this.fillToCount > ownCount ? this.fillToCount : ownCount;
            var height = 70 + (matchCount * 32);
            return height < 260 ? 260 : height;
        },
        chartOptions() {
            return {
                chart: {
                    type: "bar",
                    toolbar: { show: false },
                },
                xaxis: {
                    categories: this.data.map(function (item) {
                        return item.classification;
                    }),
                    title: {
                        text: "Number of Partners",
                        style: {
                            fontSize: "12px",
                            fontWeight: "bold",
                        },
                    },
                },
                yaxis: {
                    labels: {
                        maxWidth: 180,
                        style: {
                            fontSize: "11px",
                        },
                    },
                },
                colors: this.getColorPalette(),
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 6,
                        borderRadiusApplication: "end",
                        barHeight: "55%",
                        distributed: true,
                    },
                },
                legend: { show: false },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    style: {
                        fontSize: "11px",
                        fontWeight: 700,
                        colors: ["#1e293b"],
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " partner" + (val === 1 ? "" : "s");
                        },
                    },
                },
                grid: {
                    borderColor: "#f1f5f9",
                    xaxis: { lines: { show: true } },
                    yaxis: { lines: { show: false } },
                },
            };
        },
        chartSeries() {
            return [{
                name: "Partners",
                data: this.data.map(function (item) {
                    return item.count;
                }),
            }];
        }
    },
    methods: {
        onBarSelect: function (event, chartContext, config) {
            var index = config && typeof config.dataPointIndex === "number" ? config.dataPointIndex : -1;
            var selectedItem = this.data && index >= 0 ? this.data[index] : null;
            if (selectedItem && selectedItem.classification) {
                this.onClassificationSegmentClick(selectedItem.classification);
            }
        },
        onClassificationSegmentClick(label) {
            this.$emit("classification-clicked", label);
        },
        getColorPalette() {
            return [
                "#0EA5E9", "#8B5CF6", "#F59E0B", "#10B981", "#EC4899",
                "#6366F1", "#14B8A6", "#F97316", "#A855F7", "#22C55E"
            ];
        }
    }
};
</script>

<style scoped>
.chart-container {
    cursor: pointer;
}
.chart-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 260px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px dashed #cbd5e1;
}
.chart-empty-icon {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    opacity: 0.6;
}
.chart-empty-text {
    font-size: 0.9375rem;
    color: #64748b;
}
</style>
